require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-less-is-more-dsls-ai.json") })
        }
      }, "path---blog-less-is-more-dsls-ai");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-less-is-more-dsls-ai!./.cache/json/blog-less-is-more-dsls-ai.json
// module id = 755
// module chunks = 231608221292675